import BaseModel from "../../base_model.js";

class RawMemberUserModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "email",
        required: true
      },
      {
        name: "password",
        displayName: this.fieldDisplayName("password"),
        type: "password",
        required: true
      }
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

}
const MemberUserModel = new RawMemberUserModel();

export { RawMemberUserModel, MemberUserModel }

